import React, { useState } from 'react'
import { Button } from '../ui'

/**
 * Form for sending connection requests to other users
 */
const ConnectionRequestForm = ({ onSubmit, onCancel }) => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()

    // Basic validation
    if (!email || !email.includes('@')) {
      setError('Please enter a valid email address')
      return
    }

    onSubmit(email)
  }

  return (
    <div className="mb-6 p-4 border border-gray-200 rounded-lg">
      <h3 className="text-lg font-medium mb-3">Connect with User</h3>

      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label
            htmlFor="connectionEmail"
            className="block mb-1 text-sm font-medium text-gray-700"
          >
            User Email
          </label>
          <input
            id="connectionEmail"
            type="email"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter user's email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </div>

        <div className="flex justify-end gap-2">
          <Button type="submit">Send Request</Button>
        </div>
      </form>
    </div>
  )
}

export default ConnectionRequestForm
